// extracted by mini-css-extract-plugin
module.exports = {"viewAllWrapper":"PdpRespSimilarItemsGridSeller__viewAllWrapper__6c1c2d6b"};